import React from 'react';
import './BeforeAfter2.css';

const BeforeAfter2 = (props) => {
  return (
    <div className="project-card">
        <div className="project-title">
      <h2 >{props.title}</h2></div>




       <div className="before-after-wrapper">

      <div className="comparison-container split-layout">
        {/* BEFORE - single image */}
        <div className="before-container">
          <img
            src={props.i1}
            alt="Before"
            className="image"
          />
                  <div className="label before">Avant</div>
        </div>

        {/* AFTER - two stacked images */}
        <div className="after-container">
          <div className="after-half">
            <img
            src={props.i2}
              alt="After Top"
              className="image"
            />
          </div>
          <div className="after-half">
            <img
            src={props.i3}
              alt="After Bottom"
              className="image"
            />
          </div>
        <div className="label after">Après</div>        </div>
      </div>

    </div>
    </div>
  );
};

export default BeforeAfter2;
